var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Modal } from '@hn-ui/modals';
import { memo } from 'react';
import { styled } from 'styled-components';
import { InvitationSuccessIcon } from '../../Icons/InvitationSuccessIcon';
import { ModalContainer, ModalTitle, ModalInfo, ModalHeader } from './Common';
var TextWrapper = styled.span.withConfig({ displayName: "TextWrapper", componentId: "sc-1tjpxv7" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  line-break: normal;\n"], ["\n  line-break: normal;\n"])));
var InvitationSuccessModal = memo(function (_a) {
    var isOpen = _a.isOpen, onClose = _a.onClose;
    return (_jsx(Modal, __assign({ showCloseButton: true, open: isOpen, onClose: onClose, size: 's', showOverlay: true }, { children: _jsx(ModalContainer, { children: _jsxs(ModalHeader, { children: [_jsx(InvitationSuccessIcon, {}, void 0), _jsx(ModalTitle, { children: "Invitation email has been sent" }, void 0), _jsx(ModalInfo, { children: _jsx(TextWrapper, { children: "Your teacher assistant is now able to register and join your class on Happy Numbers." }, void 0) }, void 0)] }, void 0) }, void 0) }), void 0));
});
export { InvitationSuccessModal };
var templateObject_1;
